import { OptionalMark } from "./components/FormDisplayContext";
import { useFormContext } from "react-hook-form";

import { ui } from "@patient-watch/ui";
import type { LooseRHFField } from "./utils/loose-rhf-field";
import { FormFieldLockedControl } from "./components/formFieldLockedControl";
import { FormFieldLabelWithAccessory } from "./components/formFieldLabelRow";
import { getTestId } from "./utils/getTestId";

interface Props {
    name: string;
    placeholder?: string;
    className?: string;
    label?: string;
    description?: string;
    required?: boolean;
    labelTrailing?: React.ReactNode;
}

const Textarea: React.FC<Props> = ({
    name,
    placeholder,
    className,
    label,
    description,
    required = false,
    labelTrailing,
}) => {
    const { control } = useFormContext();
    return (
        <ui.FormField
            control={control}
            name={name}
            data-cy={name}
            render={({ field }: { field: LooseRHFField }) => (
                <ui.FormItem>
                    {label && (
                        <FormFieldLabelWithAccessory
                            label={
                                <ui.FormLabel>
                                    {label}
                                    {!required && <OptionalMark />}
                                </ui.FormLabel>
                            }
                            labelTrailing={labelTrailing}
                        />
                    )}
                    {description && <ui.FormDescription>{description}</ui.FormDescription>}
                    <FormFieldLockedControl>
                        <ui.FormControl>
                            <ui.Textarea
                                placeholder={placeholder}
                                className={className}
                                {...field}
                                data-testid={getTestId(name, "input")}
                            />
                        </ui.FormControl>
                    </FormFieldLockedControl>
                    <ui.FormMessage />
                </ui.FormItem>
            )}
        />
    );
};

export default Textarea;
